import {DiscountTooltip, HeaderPaymentDetailsCard, TotalCostTooltip,} from "pages/user/components";
import {useState} from "react";
import styled from "styled-components";
import {DateCard} from "ui/base/dateCard/DateCard";
import {ChevronDownIcon} from "ui/icons/inputIcons/ChevronDownIcon";
import {defaultThemeColors, themeColor, themeFontSize} from "ui/theme";
import {CancellationPolicyContent} from "../components/CancellationPolicyContent";
import {USDollar} from "utils";
import {allClasses} from "conts";

export const PaymentCard = ({
                                teacherInfo,
                                lessonsCost,
                                timing,
                                numberOfStudents,
                                onlineType,
                                fullName,
                                cancellation,
                            }) => {
    const [showCancellationPolicy, setShowCancellationPolicy] = useState(false);

    const classType = allClasses?.find((item => item.value.toLowerCase() === timing?.[0]?.type.toLowerCase()))?.label
    const onlineCat = onlineType === "online" ? "Online" : "In-person"

    return (
        <DetailsCard>
            <HeaderWrapper>
                <HeaderPaymentDetailsCard
                    profilePic={teacherInfo?.profile_pic}
                    title={teacherInfo?.subject_sub_category}
                    rate={teacherInfo?.rate}
                    review={teacherInfo?.review}
                    classType={classType}
                    onlineType={onlineCat}
                    levelOfStudent={teacherInfo?.level_of_student?.replaceAll?.(
                        ",",
                        ", "
                    )}
                />
            </HeaderWrapper>
            {!!teacherInfo?.teacher_discount_policy.length ? (
                <DiscountTooltip discountList={teacherInfo?.teacher_discount_policy}/>
            ) : null}
            <ContentWrapper>
                <ClassDetails>
                    {timing.map(({id, date, time, cost, type}) => (
                        <DateCard
                            key={`${id}${date}`}
                            date={{
                                date,
                                time,
                                cost,
                                type,
                            }}
                        />
                    ))}
                </ClassDetails>

                <Summary>

                    <InfoContainer>
                        <span>{numberOfStudents}</span>

                        {lessonsCost.discount === 0 ? null :
                            <DiscountText>{"Total price after discount"}</DiscountText>}
                    </InfoContainer>
                    <SummaryRow>
                        <TotalCost>
                            <span>Total (USD)</span>
                            <TooltipWrapper>
                                <TotalCostTooltip costData={lessonsCost}/>
                                {USDollar.format(lessonsCost.totalCost)}
                            </TooltipWrapper>
                        </TotalCost>
                    </SummaryRow>
                    <CancellationButton
                        type="button"
                        onClick={() => setShowCancellationPolicy((prev) => !prev)}
                    >
                        <span>Cancellation Policy</span>
                        <ChevronIconWrop isOpen={showCancellationPolicy}>
                            <ChevronDownIcon color="#191D3A"/>
                        </ChevronIconWrop>
                    </CancellationButton>
                    {showCancellationPolicy && (
                        <CancellationPolicyContent
                            policy={cancellation}
                            fullName={fullName}
                        />
                    )}
                </Summary>
            </ContentWrapper>
        </DetailsCard>
    );
};

const DetailsCard = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    height: fit-content;
    gap: 1.5rem;
    background-color: ${defaultThemeColors.white};
    box-shadow: 0 10px 30px 0 rgba(13, 11, 134, 0.071);
    border-width: 1px;
    border-style: solid;
    border-color: rgba(13, 11, 134, 0.05);
    border-radius: 5px;
    min-height: 0;
    max-height: fit-content;
    padding: 1rem;
    max-width: 600px;
    order: 1;
    margin-inline: auto;
    @media (min-width: 1024px) {
        order: 2;
        margin-right: unset;
    }
`;

const HeaderWrapper = styled.div`
    display: grid;
    gap: 8px;
`;

const ContentWrapper = styled.div`
    padding-right: 0.5rem;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    overflow: auto;
    gap: 1rem;

    &::-webkit-scrollbar {
        width: 8px;
    }

    &::-webkit-scrollbar-track {
        border-radius: 8px;
        background-color: ${themeColor("bgNeutral")};
    }

    &::-webkit-scrollbar-thumb {
        border-radius: 8px;
        background-color: ${themeColor("buttonBgNeutral")};
    }
`;

const ClassDetails = styled.div`
    display: grid;
    gap: 1rem;
`;

const CancellationButton = styled.button`
    background-color: transparent;
    border: none;
    font-size: ${themeFontSize("regular")};
    font-family: var(--font-secondary);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
`;

const ChevronIconWrop = styled.span`
    transform: ${({isOpen}) => (isOpen ? "rotate(180deg)" : "rotate(0deg)")};
`;

const Summary = styled.div`
    display: grid;
    gap: 1rem;

    & > span {
        opacity: 0.5;
    }
`;

const SummaryRow = styled.div`
    display: flex;
    justify-content: space-between;
    font-size: ${themeFontSize("regular")};
    font-weight: 600;
    padding-bottom: 1.2rem;
    border-bottom: 1px solid rgba(25, 29, 58, 0.1);
`;

const TotalCost = styled.span`
    width: 100%;
    display: flex;
    align-items: center;
    font-size: ${themeFontSize("big")};
    font-weight: bold;
    color: ${themeColor("txt")};
`;

const TooltipWrapper = styled.span`
    display: flex;
    align-items: center;
    gap: 12px;
    margin-left: 2rem;
`;

const InfoContainer = styled.div`
    display: flex;
    gap: 8px;
`

const DiscountText = styled.p`
    color: ${themeColor('blue')};
`